import { CosmicJSClient } from "../../apis/cosmicjs-client";
import { Category } from "../../domain/help/help-entity";

const CATEGORY_OBJECT_TYPE = "categories" as const;

const BUCKET = `graffer-console-contents` as const;

class CategoryListService extends CosmicJSClient {
  constructor() {
    super(BUCKET);
  }

  async fetchCategoryList(productId?: string): Promise<Category[]> {
    const result = await this.fetch<Category>(
      JSON.stringify({
        type: CATEGORY_OBJECT_TYPE,
      }),
      "id,slug,title,metadata.children,metadata.description,metadata.isvisibleinnavigation",
      "-order",
    );

    // CosmicJSのqueryの仕様でmetafieldは１階層目までしか検索対象にできないため、ここでフィルタリング
    if (productId) {
      result.objects = result.objects.map((category) => {
        category.metadata.children = category.metadata.children.filter(
          (child) => child.metadata.product.id === productId,
        );
        return category;
      });
    }

    return result.objects;
  }
}

export const categoryListService = new CategoryListService();
